import { LocationDTO } from '../api/model/location-dto';

export const locationToAddress = (location?: Pick<LocationDTO, 'street' | 'number' | 'zip' | 'city'> | null): Array<string> => {
    if (!location) {
        return [];
    }

    const street = `${ location.street } ${ location.number ?? '' }`.trim();
    const place = `${ location.zip ?? '' } ${ location.city }`.trim();

    return [street, place].filter(text => !!text.length);
};
